export function capitalizeString(input: string) {
    // Check if the input string is empty
    if (!input) {
        return input;
    }

    // Capitalize the first letter and concatenate the rest of the string
    return input.charAt(0).toUpperCase() + input.slice(1);
}
